import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const BreadCrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean);

  return (
    <nav aria-label="breadcrumb" className="my-3">
      <ol className="breadcrumb bg-white p-2 rounded">
        <li className="breadcrumb-item">
          <Link to="/" className="text-decoration-none" style={{ fontSize: "1rem"}}>Home</Link>
        </li>
        {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          const displayName = name
            .replace(/-/g, ' ')
            .replace(/\b\w/g, (c) => c.toUpperCase());

          return isLast ? (
            <li
              key={routeTo}
              className="breadcrumb-item active"
              style={{ fontSize: "1rem"}}
              aria-current="page"
            >
              {displayName}
            </li>
          ) : (
            <li key={routeTo} className="breadcrumb-item" style={{ fontSize: "1rem"}}>
              <Link to={routeTo} className="text-decoration-none">
                {displayName}
              </Link>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BreadCrumbs;